<script lang="ts">
  import { searchFilter, updateSearchFilter } from "state/page";

  function onChange(this: HTMLInputElement) {
    updateSearchFilter("nrkImages", this.checked);
  }
</script>

<label>
  <input
    type="checkbox"
    class="org-input"
    checked={$searchFilter.nrkImages === true}
    on:change={onChange}
  />
  <span>NRK bilder</span>
</label>

<style>
  /** Alignment is off with default values, but shouldn't need this much tweaking */
  label {
    display: flex;
    gap: var(--org-xsmall);
    align-items: center;
  }
</style>
